export default "__VITE_ASSET__XzoLK2nw__"